var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.3552 0 0 14.3552 0 32C0 49.6448 14.3552 64 32 64C49.6448 64 64 49.6448 64 32C64 14.3552 49.6448 0 32 0ZM25.6032 46.1216L13.7216 34.2656L18.24 29.7344L25.5968 37.0784L42.5376 20.1376L47.0624 24.6624L25.6032 46.1216Z",
    fill: "#00984C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.3ee1f2e2a9a0073d10ebfae9494a48b2.svg";
export { ForwardRef as ReactComponent };